export const MY_PROFILE_TRANSLATE = {
    myProfile: {
        breadcrumbName: "My Profile",
        messages: {
            changePassword: "Password changed successfully"
        },
        read: {
            tabs: {
                data: "General",
                changePassword: "Change Password"
            }
        },
        save: {
            form: {
                fields: {
                    name: {
                        label: "Name",
                        placeholder: "Enter your name"
                    },
                    email: {
                        label: "Email",
                        placeholder: "Enter your email"
                    },
                    currentPassword: {
                        label: "Current Password",
                        placeholder: "Enter your current password"
                    },
                    password: {
                        label: "New Password",
                        placeholder: "Enter your new password"
                    },
                    passwordConfirmation: {
                        label: "Confirm New Password",
                        placeholder: "Confirm your new password"
                    }
                }
            }
        }
    }
}
